import {
  getClientClassificationTags,
  getClassificationTagColor,
  getClassificationTagTitle,
} from '@/lib/clients/classification-tags';
import type { Client } from '@/lib/types';
import type { CachedPostureAnalysis } from '@/context/clients-cache-context';
import { cn } from '@/lib/utils';
import { TagPill } from './TagPill';

interface ClientClassificationBadgesProps {
  client: Pick<Client, 'id' | 'classification'>;
  allPostureAnalyses?: CachedPostureAnalysis[];
  className?: string;
  emptyLabel?: string;
  /** Tighter pills for the roster table. */
  compact?: boolean;
}

export function ClientClassificationBadges({
  client,
  allPostureAnalyses,
  className,
  emptyLabel = '—',
  compact = false,
}: ClientClassificationBadgesProps) {
  const tags = getClientClassificationTags(client, { allPostureAnalyses });

  if (tags.length === 0) {
    return <span className="text-muted-foreground text-sm">{emptyLabel}</span>;
  }

  return (
    <div className={cn('flex flex-wrap', compact ? 'gap-0.5' : 'gap-1', className)}>
      {tags.map((tag) => {
        const color = getClassificationTagColor(tag.id);
        const fullTitle = `${tag.label} — ${getClassificationTagTitle(tag.id)}`;
        return (
          <TagPill
            key={tag.id}
            color={color}
            size={compact ? 'sm' : 'md'}
            title={fullTitle}
            aria-label={fullTitle}
          >
            {tag.label}
          </TagPill>
        );
      })}
    </div>
  );
}
